const getDateLabelText = (label) =>
  `${label} (${I18n.t('date.formats.date_picker')})`;

export default getDateLabelText;
